export default {
    title: "Vérification d'adresse",
    header: "@:views.address.verified.title",
    message: "Merci d'avoir vérifié votre adresse. Vous pouvez désormais la choisir comme adresse de livraison lorsque vous passez une commande.",
}